import { ClientType, InsurerType, PartnershipType } from '../../types';
import { AutocompleteSelectOption } from '../grid-components/grid-types';

export enum CiStatusFilter {
  All = 'all',
  Active = 'active',
  Inactive = 'inactive',
}

export enum ContractStatusFilter {
  All = 'all',
  Active = 'active',
  NotActive = 'not_active',
}

export interface ClientInsurerIndexFilterModel {
  clientIds: number[];
  insurerIds: number[];
  partnershipIds: number[];
  billingTypes: string[];
  ciStatus: CiStatusFilter;
  contractStatus: ContractStatusFilter;
}

export const defaultClientInsurerIndexFilters: ClientInsurerIndexFilterModel = {
  clientIds: [],
  insurerIds: [],
  partnershipIds: [],
  billingTypes: [],
  ciStatus: CiStatusFilter.All,
  contractStatus: ContractStatusFilter.All,
};

export interface RawClientInsurerIndexFilterValues {
  clients: ClientType[];
  insurers: Omit<InsurerType, 'eligibilityRef' | 'memberIdRequired'>[];
  partnerships: PartnershipType[];
  billingTypes: AutocompleteSelectOption[];
  ciStatus: CiStatusFilter;
  contractStatus: ContractStatusFilter;
}
